import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";
export default {
  name: "homePage",
  data: () => {
    return {
      typeForm: 2,
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      confirmPassword: "",
    };
  },
  methods: {
    loginGoogle() {
      const provider = new firebase.auth.GoogleAuthProvider();
      firebase
        .auth()
        .signInWithPopup(provider)
        .then((result) => {
          this.$loading(true);
          console.log("googl", result);
          if (result.additionalUserInfo.isNewUser == true) {
            var dataToSend = {
              firstName: result.additionalUserInfo.profile.given_name,
              lastName: result.additionalUserInfo.profile.family_name,
              email: result.additionalUserInfo.profile.email,
              password: "passwordGiftstore",
              isVerified: true,
            };
            axios
              .post(
                "https://giftstore-blog.herokuapp.com/api/user/signup",
                dataToSend
              )
              .then((response) => {
                this.$loading(false);
               
                console.log("test123", response);
                localStorage.setItem("Giftstore-T", response.data.token);
                localStorage.setItem("Giftstore-U", response.data.user._id);
                this.$store.commit("setUserInfo", response.data.user);
                console.log("store", this.$store.getters.getUserInfo);
                this.$router.push({ name: "Home" });
              })
              .catch((error) => {
                this.$loading(false);
                this.errorMessage = error.message;
                console.error("There was an error!", error);
                this.$toast.open({
                  message: "Erreur lors de la connexion",
                  type: "error",
                  position: "top-right",
                  // all of other options may go here
                });
              });
          } else {
            var dataToSendLogin = {
              email: result.additionalUserInfo.profile.email,
              password: "passwordGiftstore",
            };
            axios
              .post(
                "https://giftstore-blog.herokuapp.com/api/user/login",
                dataToSendLogin
              )
              .then((response) => {
                this.$loading(false);
                this.$toast.open({
                  message: "Bienvenu",
                  type: "success",
                  // all of other options may go here
                });
                console.log("test123", response);
                localStorage.setItem("Giftstore-T", response.data.token);
                localStorage.setItem("Giftstore-U", response.data.user._id);
                this.$store.commit("setUserInfo", response.data.user);
                console.log("store", this.$store.getters.getUserInfo);
                this.$router.push({ name: "Home" });
              })
              .catch((error) => {
                this.$loading(false);
                console.error("There was an error!", error);
                this.$toast.open({
                  message: "Email ou Mot de passe est incorrect",
                  type: "error",
                  // position: 'top-right'
                  // all of other options may go here
                });
              });
            console.log("old");
          }
        })
        .catch((err) => {
          console.log("erre", err);
        });
    },
    loginFacebook() {
      var providerFb = new firebase.auth.FacebookAuthProvider();

      firebase
        .auth()
        .signInWithPopup(providerFb)
        .then((result) => {
          console.log("googl", result);
        })
        .catch((err) => {
          console.log("erre", err);
        });
    },
    addUser() {
      if (this.confirmPassword == this.password) {
        var dataToSend = {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          password: this.password,
        };
        axios
          .post(
            "https://giftstore-blog.herokuapp.com/api/user/signup",
            dataToSend
          )
          .then((response) => {
            this.$toast.open({
              message: "Compte bien créer",
              type: "success",
              position: "top-right",
              // all of other options may go here
            });
            console.log("test123", response);
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
            this.$toast.open({
              message: "Email ou Mot de passe est incorrect",
              type: "error",
              position: "top-right",
              // all of other options may go here
            });
          });
      } else {
        this.$toast.open({
          message: "Vérifiez votre mot de passe",
          type: "error",
          position: "top-right",
          // all of other options may go here
        });
      }
    },
    connectUser() {
      var dataToSend = {
        email: this.email,
        password: this.password,
      };
      console.log(dataToSend);

      axios
        .post("https://giftstore-blog.herokuapp.com/api/user/login", dataToSend)
        .then((response) => {
          this.$toast.open({
            message: "Bienvenu",
            type: "success",
            // all of other options may go here
          });
          console.log("test123", response);
          localStorage.setItem("Giftstore-T", response.data.token);
          localStorage.setItem("Giftstore-U", response.data.user._id);
          this.$store.commit("setUserInfo", response.data.user);
          console.log("store", this.$store.getters.getUserInfo);
          this.$router.push({ name: "Home" });
        })
        .catch((error) => {
          console.error("There was an error!", error);
          this.$toast.open({
            message: "Email ou Mot de passe est incorrect",
            type: "error",
            // position: 'top-right'
            // all of other options may go here
          });
        });
    },
    sendEmail() {
      var dataToSend = {
        email: this.email,
      };
      axios
        .post(
          "https://giftstore-blog.herokuapp.com/api/user/subscribeMail",
          dataToSend
        )
        .then((response) => {
          console.log("test123", response);
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
        });
    },
  },
};
